import React from 'react';

interface SpecItem {
  subtitle: string;
  descriptions: string[];
}

interface EnterpriseSpecsListProps {
  columns: {
    column1: SpecItem[];
    column2: SpecItem[];
    column3: SpecItem[];
  };
}

export const EnterpriseSpecsList: React.FC<EnterpriseSpecsListProps> = ({
  columns,
}) => {
  const tabletColumns = {
    columnA: [
      ...columns.column1,
      ...columns.column2.slice(0, Math.ceil(columns.column2.length / 2)),
    ],
    columnB: [
      ...columns.column2.slice(Math.ceil(columns.column2.length / 2)),
      ...columns.column3,
    ],
  };

  return (
    <>
      {/* Desktop view (3 columns) */}
      <div className="enterprise-specs-section desktop-view">
        <div className="enterprise-specs-column">
          {columns.column1.map((item, index) => (
            <SpecItem key={`col1-${index}`} item={item} />
          ))}
        </div>
        <div className="enterprise-specs-column">
          {columns.column2.map((item, index) => (
            <SpecItem key={`col2-${index}`} item={item} />
          ))}
        </div>
        <div className="enterprise-specs-column">
          {columns.column3.map((item, index) => (
            <SpecItem key={`col3-${index}`} item={item} />
          ))}
        </div>
      </div>

      {/* Tablet view (2 columns) */}
      <div className="enterprise-specs-section tablet-view">
        <div className="enterprise-specs-column">
          {tabletColumns.columnA.map((item, index) => (
            <SpecItem key={`tabA-${index}`} item={item} />
          ))}
        </div>
        <div className="enterprise-specs-column">
          {tabletColumns.columnB.map((item, index) => (
            <SpecItem key={`tabB-${index}`} item={item} />
          ))}
        </div>
      </div>

      {/* Mobile view (1 column) */}
      <div className="enterprise-specs-section mobile-view">
        <div className="enterprise-specs-column">
          {[columns.column1, columns.column2, columns.column3].map(
            (group, groupIndex) => (
              <React.Fragment key={`mob-group-${groupIndex}`}>
                {group.map((item, itemIndex) => (
                  <SpecItem
                    key={`mob-${groupIndex}-${itemIndex}`}
                    item={item}
                  />
                ))}
                {groupIndex < 2 && <div style={{ height: '30px' }} />}
              </React.Fragment>
            ),
          )}
        </div>
      </div>
    </>
  );
};

const SpecItem: React.FC<{ item: SpecItem }> = ({ item }) => {
  return (
    <div className="enterprise-specs-item">
      <h2 className="enterprise-specs-item-subtitle">{item.subtitle}</h2>
      {item.descriptions.map((desc, i) => (
        <p key={i} className="enterprise-specs-item-description">
          {desc}
        </p>
      ))}
    </div>
  );
};
